export class Tag {
    fieldName : string = '';
    fieldValue : string = '';
    categoryId : string = '';
}

export class InsertTemplateModel {
    templateName : string = '';
    htmlContent : string = '';
}

export class UpdateTemplateModel {
    templateId: string='';
    templateName : string = '';
    htmlContent : string = '';
}

export class TagsData {
    Text : string = "";
    Number : string = '';
    Date : string = '';
}